// Mock data for Reload Freight

export const routes = [
  {
    id: 1,
    from: "Chennai",
    to: "Kadapa",
    distance: "250 km"
  },
  {
    id: 2,
    from: "Kadapa",
    to: "Chennai",
    distance: "250 km"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Lower Prices Using Return Trips",
    description: "Save up to 40% by utilizing empty return trips of trucks",
    icon: "indian-rupee"
  },
  {
    id: 2,
    title: "Verified Truck Owners",
    description: "All truck owners are verified for your safety and trust",
    icon: "shield-check"
  },
  {
    id: 3,
    title: "Fast Booking via WhatsApp / Call",
    description: "Quick and easy booking process through WhatsApp or phone",
    icon: "phone"
  },
  {
    id: 4,
    title: "Focused Routes",
    description: "Currently serving Chennai ↔ Kadapa and Tirupati (TPT)",
    icon: "map"
  }
];

export const trustFeatures = [
  {
    id: 1,
    title: "Contact Number Required",
    description: "We collect valid phone numbers for direct communication"
  },
  {
    id: 2,
    title: "Direct Communication",
    description: "Connect directly with truck owners for negotiations"
  },
  {
    id: 3,
    title: "No Platform Commission",
    description: "Deal directly with truck owners. No hidden platform fees."
  },
  {
    id: 4,
    title: "WhatsApp Support",
    description: "24/7 assistance available on WhatsApp"
  }
];
